import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckForUpdateService {
  private updates = inject(SwUpdate);

  constructor() {
    if (!this.updates.isEnabled) {
      console.log('Service workers are not supported or disabled in this browser');
      return;
    }

    // Check for updates every 6 hours
    interval(6 * 60 * 60 * 1000).subscribe(() => this.checkForUpdates());

    // Listen for available updates
    this.updates.versionUpdates.subscribe((evt) => {
      if (evt.type === 'VERSION_READY') {
        console.log('New version available, reloading...');
        this.reloadPage();
      }
    });
  }

  public checkForUpdates(): void {
    if (!this.updates.isEnabled) {
      return;
    }

    this.updates
      .checkForUpdate()
      .then(() => console.log('Checking for updates...'))
      .catch((err) => console.error('Failed to check for updates:', err));
  }

  private clearStorage(): void {
    // Clear localStorage
    localStorage.clear();

    // Clear sessionStorage
    sessionStorage.clear();

    // Clear IndexedDB
    indexedDB.databases().then((dbs) => {
      dbs.forEach((db) => {
        indexedDB.deleteDatabase(db.name!);
      });
    });

    // Clear cache
    if ('caches' in window) {
      caches.keys().then((keys) => {
        keys.forEach((key) => caches.delete(key));
      });
    }
  }

  private reloadPage(): void {
    // Clear all storage before reloading
    this.clearStorage();

    if (this.updates.isEnabled) {
      this.updates.activateUpdate().then(() => {
        document.location.reload();
      });
    } else {
      document.location.reload();
    }
  }
}
